import { ReportRecord } from '../../../../../models/report.model';
import { TemplateFieldsDisplayFn } from '../../../../../models/template.model';
import { displayFnWrapper } from '../../../utils/dynamic-data-retrievers';
import { PropertyType, propertyTypeDisplayFnFactory } from '../us.common';
import {
  getFloorSuiteVals,
  US_AVAILABILITY_COMMON_BODY_FIELDS,
  US_AVAILABILITY_COMMON_FOOTER_FIELDS,
  US_AVAILABILITY_COMMON_HEADER_FIELDS,
} from './us-availability.common';

const officeDisplayFnWrapper = propertyTypeDisplayFnFactory(PropertyType.Office);

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...US_AVAILABILITY_COMMON_HEADER_FIELDS(PropertyType.Office),
  ...US_AVAILABILITY_COMMON_BODY_FIELDS(PropertyType.Office),
  ...US_AVAILABILITY_COMMON_FOOTER_FIELDS,
  163: { displayFn: officeDisplayFnWrapper }, // 163 - Full Floor Available
  165: { displayFn: displayFnWrapper }, // 165 - Floors
  191: {
    displayFn: (record: ReportRecord, _, suite, floor) => {
      const result = getFloorSuiteVals(record, floor, suite);
      return result;
    },
  }, // 191 - Floor | Suite
  215: { displayFn: displayFnWrapper }, // 215 - Minimum Floor Area
  216: { displayFn: displayFnWrapper }, // 216 - Elevator Count
  217: { displayFn: displayFnWrapper }, // 217 - Freight Elevator Count
  218: { displayFn: officeDisplayFnWrapper }, // 218 - Parking Type
};
